import CompanyQuoteProfile from './CompanyQuoteProfile'
// Uncomment the below to migrate to stateful component
// import CompanyQuoteProfileContainer from './CompanyQuoteProfileContainer'

export { CompanyQuoteProfile }
export default CompanyQuoteProfile
// Uncomment the below to migrate to stateful component
// export { CompanyQuoteProfileContainer }
// export default { CompanyQuoteProfileContainer }
